<template>
  <DetailTemplate ref="detail" :show-related="showRelated" :show-sublings="showSublings"></DetailTemplate>
</template>

<script>
import DetailTemplate from "~/components/template/DetailTemplate.vue";
import {getArticles} from "~/api/CmsApi";

export default {
  components: {DetailTemplate},
  data() {
    return {
      showSublings: false,
      showRelated: false
    }
  },
  mounted() {
    if (this.$route.query.t === 'jianjie') {
      document.title = '峨眉山旅游网-景区简介';
      getArticles({page: 1, limit: 1, cateId: this.$cid.shrine.jingQuJianJie}).then(res => {
        if (res.code === 0) {
          const list =  res.data.records || [];
          if (list.length > 0) {
            this.$refs.detail.renderArticle(list[0]);
          }
        }
      })
    }

  }
}
</script>



// WEBPACK FOOTER //
// src/views/link/detail.vue